export const addCommasToNum = (num, per = 3, places = 2) => {
  //   // (A2) NO DECIMAL PLACES - ROUND OFF
  //   // REMOVE THIS IF YOU DON'T WANT TO ROUND OFF
    if (places == 0) {
      num = Math.round(num);
    }

  // (A3) SPLIT WHOLE & DECIMAL NUMBERS
  let cString = num.toString(),
    cDot = cString.indexOf("."),
    cWhole = "",
    cDec = "";
  if (cDot == -1) {
    cWhole = cString;
    cDec = 0;
  } else {
    cWhole = cString.substring(0, cDot);
    cDec = cString.substring(cDot + 1);
  }

  // (A4) ADD COMMAS TO WHOLE NUMBER
  let aComma = "",
    count = 0;
  if (cWhole.length > per) {
    for (let i = cWhole.length - 1; i >= 0; i--) {
      aComma = cWhole.charAt(i) + aComma;
      count++;
      if (count == per && i != 0) {
        aComma = "," + aComma;
        count = 0;
      }
    }
  } else {
    aComma = cWhole;
  }

  // (A5) ROUND OFF TO GIVEN DECIMAL PLACES
  if (places == 0) {
    cDec = "";
  } else {
    cDec = +("0." + cDec);
    cDec = cDec.toFixed(places).toString().substring(1);
  }

  // (A6) RETURN "WHOLE WITH COMMA" PLUS DECIMAL PLACES
  return aComma + cDec;
};

export const bytesToGigabytes = (bytes) => {
  return bytes / Math.pow(1000, 3);
};

export const dataSizeStringToBytes = {
  YB: (yb) => yb * Math.pow(1000, 8),
  ZB: (zb) => zb * Math.pow(1000, 7),
  EB: (eb) => eb * Math.pow(1000, 6),
  PB: (pb) => pb * Math.pow(1000, 5),
  TB: (tb) => tb * Math.pow(1000, 4),
  GB: (gb) => gb * Math.pow(1000, 3),
  MB: (mb) => mb * Math.pow(1000, 2),
  KB: (kb) => kb * 1000,
  Bytes: (bytes) => bytes,
};

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export function humanFileSize(bytes, si = false, dp = 2) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
}
